import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { TokenService } from 'src/services/token.service';

const EDUCATION_LEVEL = {
  'ens-comp-comp': 'Ensino Complementar Completo',
  'ens-comp-curs': 'Ensino Complementar Cursando',
  'ens-comp-inc': 'Ensino Complementar Incompleto',
  'ens-fund-comp': 'Ensino Fundamental Completo',
  'ens-fund-curs': 'Ensino Fundamental Cursando',
  'ens-fund-inc': 'Ensino Fundamental Incompleto',
  'ens-med-comp': 'Ensino Médio Completo',
  'ens-med-curs': 'Ensino Médio Cursando',
  'ens-med-inc': 'Ensino Médio Incompleto',
  'ens-sup-comp': 'Ensino Superior Completo',
  'ens-sup-curs': 'Ensino Superior Cursando',
  'ens-sup-inc': 'Ensino Superior Incompleto',
  'tec-med-comp': 'Técnico Completo',
  'tec-med-curs': 'Técnico Cursando',
  'tec-med-inc': 'Técnico Incompleto',
}

@Component({
  selector: 'app-candidate-edit-dialog',
  templateUrl: './candidate-edit-dialog.component.html',
  styleUrls: ['./candidate-edit-dialog.component.scss']
})
export class CandidateEditDialogComponent implements OnInit {

  form: FormGroup;
  formGroup: FormGroup;
  submiting: boolean = false;
  candidateId: string = null;
  vacancies: Array<any> = [];
  educations$: Observable<any>;
  experiences$: Observable<any>;
  currentProcessListId: string;
  levelEducation: string = null;
  readOnly: boolean = false;
  keywordsSearch: any = {};
  hideCandidateData: boolean = true;
  companyRoot: boolean;
  showUserData: boolean = false;
  isLoading: boolean = true;
  relatorio: string = null;
  infoProcess: any;
  useIA: boolean;

  constructor(
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private processList: ProcessListService,
    private snackbar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private token: TokenService
  ) {
    this.form = fb.group({
      id: [null],
      firstname: [null],
      lastname: [null],
      email: [null],
      mobile: [null],
      phone: [null],
      birthdate: [null],
      age:[null],
      gender: [null],
      desiredJobTitle: [null],
      cpf: [null],
      rg: [null],
      street: [null],
      number: [null],
      city: [null],
      state: [null],
      zipCode: [null],
      district: [null],
      complement: [null],
      planSignature: [null],
      aboutMe: [null]
    })

    this.candidateId = data.candidate.id;
    this.currentProcessListId = data.processListId
    this.readOnly = data.readOnly;
    this.infoProcess = data.infoProcess;
    const user = JSON.parse(localStorage.getItem('token'));

    this.companyRoot = user.company_root as boolean;
    this.showUserData = user.show_user_data as boolean;

    if (data.keywordsSearch)
      this.keywordsSearch = data.keywordsSearch;

  }

  ngOnInit(): void {
    this.token.atualizar();
    setTimeout(()=>{
      const user = JSON.parse(localStorage.getItem('token'));
      this.useIA = !!user.use_ia;
    },250);

    this.experiences$ = this.http.get('experience', { id: this.candidateId, all: true })
      .pipe(
        map((result: any) => {

          const { data } = result;

          for (const item of data) {

            item.office = this.highlight(item.sinonimo);
            item.organization = this.highlight(item.organization);
            item.description = this.highlight(item.description);
            item.keywordsCount = this.keywordsCount(`${item.sinonimo} ${item.organization} ${item.description}`);

          }
          return data;
        }));

    this.educations$ = this.http.get('education', { id: this.candidateId, all: true })
      .pipe(map((result: any) => {
        return result.data
      }));

    this.http.get('candidate', {
      id: this.candidateId,
      processListId: this.currentProcessListId
    })
      .subscribe(
        (result: any) => {

          this.levelEducation = EDUCATION_LEVEL[result.leveleducation] || null;

          this.hideCandidateData =
            (result.candidateStatus === 'waiting' || result.candidateStatus === null)
            && !(this.companyRoot || this.showUserData);

          this.form.patchValue({
            id: result.id,
            firstname: result.firstname,
            lastname: result.lastname,
            email: result.email,
            phone: result.phone,
            mobile: result.mobile,
            birthdate: result.birthdate,
            age: result.birthdate
              ? moment().diff(moment(result.birthdate), "year")
              : null,
            gender: result.gender,
            desiredJobTitle: result.desired_job_title || result.desired_job_title2,
            cpf: result.cpf,
            rg: result.rg,
            street: result.address1,
            number: result.address2,
            city: result.city,
            state: result.state,
            zipCode: result.zipcode,
            district: result.district,
            complement: result.complement,
            planSignature: result.plan_signature,
            aboutMe: result.aboutme
          })

          if (result.report !== null) {
            this.relatorio = result.report;
            this.isLoading = false;
          } else {
            if(this.useIA){
              this.getReport();
            }
          }

        },
        err => this.errorReport.showMessage(err)
      )

    if (this.currentProcessListId) {

      this.http.save('process_list_action', {
        leads: [this.candidateId],
        processList: this.currentProcessListId,
        action: 'viewed'
      }).subscribe({
        error: (err) => this.errorReport.showMessage(err)
      })

    }

  }

  rejectCandidate() {

    let message = '';
    if (this.processList.reject(this.candidateId, this.currentProcessListId))
      message = 'Candidato rejeitado!';
    else message = 'Candidato removido da lista de rejeição!';

    this.snackbar.open(message, 'OK', { duration: 3000 });

  }

  addCandidate() {

    const data = this.form.getRawValue();
    if (!this.processList.add(data, this.currentProcessListId)) {
      this.snackbar.open('Candidato já esta na lista', 'OK', { duration: 3000 });
    } else {

      if (this.processList.hasCandidateRejected(this.candidateId, this.currentProcessListId))
        this.processList.reject(this.candidateId, this.currentProcessListId)

    }

  }

  openEmail() {

    const winObject = window as any;
    const email = this.form.get('email').value;

    if (winObject.IS_FLUTTER)
      winObject.launchUrl(`mailto:${email}`);
    else
      window.open(`mailto:${email}`, '_blank');

  }

  openWhatsapp() {

    const winObject = window as any;
    const phone = this.form.get('phone').value;

    if (winObject.IS_FLUTTER) {
      const url = `whatsapp://send?phone=55${phone}`;
      winObject.launchUrl(url);
    } else
      window.open(`https://wa.me/55${phone}`, '_blank');

  }

  highlight(description: string) {

    if (!description) return;

    if (this.keywordsSearch.params)
      for (const key of this.keywordsSearch.params) {

        const match = RegExp(key.trim(), 'gmi').exec(description)
        description = description.replace(new RegExp(key.trim(), 'gmi'), `<span style="background-color: yellow">${match}</span>`)

      }

    if (this.keywordsSearch.form)
      for (const key of this.keywordsSearch.form) {

        if (key) {
          const match = RegExp(key.trim(), 'gmi').exec(description)
          description = description.replace(new RegExp(key.trim(), 'gmi'), `<span style="background-color: orange">${match}</span>`)
        }

      }

    return this.sanitizer.bypassSecurityTrustHtml(description);

  }

  keywordsCount(description) {

    let count = {
      params: 0,
      form: 0
    };

    if (this.keywordsSearch.params)
      for (const key of this.keywordsSearch.params) {
        const regex = RegExp(key.trim(), 'gmi');
        while (regex.exec(description) !== null) {
          count.params += 1;
        }
      }

    if (this.keywordsSearch.form)
      for (const key of this.keywordsSearch.form) {
        if (key) {
          const regex = RegExp(key.trim(), 'gmi');
          while (regex.exec(description) !== null) {
            count.form += 1;
          }
        }
      }

    return count;

  }

  getReport() {
    this.isLoading = true;
    
    const dados: any = {}; // Criar um objeto corretamente

    dados["id"] = this.candidateId;
    dados["id_process"] = this.currentProcessListId;
    dados["idade"] = this.form.controls["age"].value;
    dados["sexo"] = this.form.controls["gender"].value;
    dados["sobre"] = this.form.controls["aboutMe"].value;
    dados["cargos"] = this.form.controls["desiredJobTitle"].value;

    // Pegando valores de observáveis antes de enviar para evitar referência circular
    this.experiences$.pipe(take(1)).subscribe((experiences) => {
      this.educations$.pipe(take(1)).subscribe((educations) => {
        dados["ex_profissionais"] = experiences;
        dados["ex_escolares"] = educations;

        try {
          // Tentativa de evitar referência circular em infoProcess
          this.processList.getById(this.currentProcessListId).subscribe({
            next: (infoProcess) => {
              dados["info_process"] = JSON.parse(JSON.stringify(infoProcess));
            },
            error: (err) => {
              console.error("Erro ao buscar infoProcess:", err);
              dados["info_process"] = null;
            }
          });

          this.http.save("ai-generator:reports", dados).subscribe(
            (result: any) => {
              if (result && result.data && result.data.text) {
                this.relatorio = result.data.text; // Armazena o texto do relatório
                this.isLoading = false;
              }
            },
            (error) => {
              console.error(error);
              this.isLoading = false;
            }
          );
        } catch (e) {
          console.error("Erro ao processar infoProcess:", e);
        }
      });
    });
  }

}
